import { __decorate } from "tslib";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import domtoimage from "dom-to-image";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import * as XLSX from "xlsx";
//import User from '@/classes/Users/User';
//import HolidayCollection from '@/classes/HolidayCollection';
import HolidayList from "@/types/Holiday/HolidayList";
import UserList from "@/types/User/UserList";
let AbsenceList = class AbsenceList extends Vue {
    weekNo(fullDate) {
        return moment(fullDate).format("w");
    }
    isToday(date) {
        return date === new Date().toISOString().split("T")[0];
    }
    downloadimg() {
        domtoimage
            //@ts-ignore
            .toJpeg(document.getElementById("absenceList"), { quality: 1 })
            .then((dataUrl) => {
            const link = document.createElement("a");
            link.download = `absence_${new Date().toISOString()}.jpeg`;
            link.href = dataUrl;
            link.click();
        });
    }
    downloadxlsx() {
        try {
            const selected = moment(this.$store.getters.getSelectedDate)
                .endOf("month")
                .format("YYYY-MM-DD");
            const [year, month, days] = selected.split("-");
            let users = JSON.parse(JSON.stringify(this.$data.filteredUsers));
            users = users.map((user) => {
                const { absenceDates } = user;
                // Format keys for nice display
                user["Name"] = `${user.firstName} ${user.lastName}`;
                delete user.firstName;
                delete user.lastName;
                // Add all dates for the month as keys
                for (let day = 1; day <= Number(days); day++) {
                    user[`${year}-${month}-${("0" + day).slice(-2)}`] = "";
                }
                // Append absent dates
                absenceDates.forEach((absenceDate) => (user[absenceDate.split("T")[0]] = "😎"));
                // Delete unwanted keys
                delete user.absenceDates;
                delete user.absenceSpans;
                delete user.userId;
                delete user.userId;
                delete user.teamId;
                delete user.teamName;
                return user;
            });
            const date = new Date().toISOString();
            const wb = XLSX.utils.book_new();
            wb.Props = {
                Title: `Absence`,
                Subject: `Geshdo Absence`,
                Author: "GESDHO",
                CreatedDate: new Date(),
            };
            const ws = XLSX.utils.json_to_sheet(users);
            XLSX.utils.book_append_sheet(wb, ws, `${moment(this.$data.selectedDate)
                .startOf("month")
                .format("YYYY-MM-DD")}-${moment(this.$data.selectedDate)
                .endOf("month")
                .format("YYYY-MM-DD")}`);
            XLSX.writeFile(wb, `GESHDO_absence_${date}.xlsx`);
        }
        catch (err) {
            console.log(err);
        }
    }
    initialLoad() {
        const dateObject = {
            year: window.dateHandler.getYear(this.$store.getters.getSelectedDate),
            month: window.dateHandler.getMonthNumber(this.$store.getters.getSelectedDate),
        };
        this.$data.showLoader = true;
        Promise.all([
            this.$store.dispatch("loadHolidaysAsync", { year: dateObject.year }),
            this.$store.dispatch("getAllUsers"),
            this.$store.dispatch("loadUserTeams", dateObject),
            this.$store.dispatch("loadAbsence", dateObject),
        ])
            .then((result) => {
            this.$data.holidayList = new HolidayList(result[0].data); //set the holiday list
            this.$data.userList = new UserList(result[1].data); //create the user list
            const teamMembers = result[2].data;
            const absenceReports = result[3].data;
            //merge the user object with the members object
            const membersMerged = teamMembers.map((member) => {
                const user = this.$data.userList.getUser(member.userId)[0];
                return Object.assign(member, {
                    firstName: user.firstName,
                    lastName: user.lastName,
                });
            });
            // create a new object for all absence reports in the object
            const mergedWithAbsence = membersMerged.map((member) => {
                const absenceReportsForUser = absenceReports.filter((report) => {
                    return report.userId === member.userId;
                });
                //create the new object "absenceDates" and map the value to only include the date.
                return Object.assign(member, {
                    absenceDates: absenceReportsForUser.map((abReport) => abReport.date),
                });
            });
            this.$data.userAbsenceList = mergedWithAbsence;
            //get team name and ID
            const tempTeams = mergedWithAbsence.map((user) => {
                return Object({ teamId: user.teamId, teamName: user.teamName });
            });
            this.$data.teams = [
                ...new Set(tempTeams.map((team) => JSON.stringify(team))),
            ].map((valueString) => JSON.parse(valueString));
            // if(this.$data.teamFilters.length === 0){
            //     this.$data.teams.forEach((team: any) => {
            //    this.$data.teamFilters.push(team.teamId);
            //  });
            // }
            this.$data.userAbsenceList = this.$data.userAbsenceList.map((member) => {
                const absenceListSpans = this.calculateAbsenceLength(member);
                return Object.assign(member, { absenceSpans: absenceListSpans });
            });
            this.$data.showLoader = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "AbsenceList.vue - initialLoad");
        });
    }
    numberOfDaysToShow() {
        if (this.$data.selectedView === 1 || this.$data.showWeeks === true) {
            return 7;
        }
        try {
            return Number(moment(this.$store.getters.getSelectedDate).endOf("month").format("DD"));
        }
        catch {
            return 31;
        }
    }
    calculateAbsenceLength(user) {
        const absenceReports = user.absenceDates;
        const allRangeResults = [];
        if (absenceReports !== undefined && absenceReports.length > 0) {
            absenceReports.sort((a, b) => (a > b ? 1 : -1)); // sort by date
            let startingDate = absenceReports[0]; //set the starting point
            let rangeAdded = false; //tells the system that the range has not been added
            //if there is only one absence we add it directly
            if (absenceReports.length === 1) {
                const fromStart = window.dateHandler.daysBetweenDates(this.$store.getters.getSelectedDate, startingDate);
                allRangeResults.push({
                    fromStart,
                    from: startingDate,
                    to: startingDate,
                    numberOfDays: 1,
                    title: "(1) " + this.formatTitleDate(startingDate), //generate the title for the object when hover
                });
                rangeAdded = true;
            }
            //if there are multiple reports
            else if (absenceReports.length > 1) {
                //if there are multiple absence reports we need to check if they are in one series or not
                for (let i = 1; i <= absenceReports.length; i++) {
                    rangeAdded = false;
                    if (this.isNextDay(absenceReports[i - 1], absenceReports[i]) === false) {
                        const fromStart = window.dateHandler.daysBetweenDates(this.$store.getters.getSelectedDate, startingDate);
                        const numberOfDays = window.dateHandler.daysBetweenDates(startingDate, absenceReports[i - 1]);
                        let title = "(" +
                            numberOfDays +
                            ") " +
                            this.formatTitleDate(startingDate) +
                            " to " +
                            this.formatTitleDate(absenceReports[i - 1]);
                        if (numberOfDays === 1) {
                            //set the title to a single value if the span is only 1 long
                            title = this.formatTitleDate(startingDate);
                        }
                        allRangeResults.push({
                            fromStart,
                            from: startingDate,
                            to: absenceReports[i - 1],
                            numberOfDays,
                            title,
                        });
                        startingDate = absenceReports[i];
                        rangeAdded = true;
                    }
                }
                if (rangeAdded === false) {
                    const fromStart = window.dateHandler.daysBetweenDates(this.$store.getters.getSelectedDate, startingDate);
                    const numberOfDays = window.dateHandler.daysBetweenDates(startingDate, absenceReports[absenceReports.length - 1]);
                    allRangeResults.push({
                        fromStart,
                        from: startingDate,
                        to: absenceReports[absenceReports.length - 1],
                        numberOfDays,
                        title: "(" +
                            numberOfDays +
                            ") " +
                            this.formatTitleDate(startingDate) +
                            " to " +
                            this.formatTitleDate(absenceReports[absenceReports.length - 1]),
                    });
                }
            }
            return allRangeResults;
        }
    }
    isNonWorkingDay(date) {
        return this.$data.holidayList.isRedDay(date);
    }
    toggleView() {
        const value = this.$data.selectedView;
        if (value === 0) {
            // this.$data.numberOfDaysToShow = 31;
            this.$store.commit("setSelectedDate", {
                date: moment(this.$store.getters.getSelectedDate).format("YYYY-MM-01"),
            });
            this.initialLoad();
            this.getDateInfo();
        }
        else if (value === 1) {
            // this.$data.numberOfDaysToShow = 7;
        }
        else if (value === 2) {
            // this.$data.numberOfDaysToShow = 3;
        }
    }
    toggleWeeks() {
        if (this.$data.showWeeks === true) {
            // this.$data.numberOfDaysToShow = 7;
        }
        else {
            // this.$data.numberOfDaysToShow = 31;
        }
    }
    isAbsenceWithinRange(date) {
        let isWithinVisibleSpan = true;
        if (moment(date).local() <
            moment(this.$store.getters.getSelectedDate).local() ||
            moment(date).local() >
                moment(this.$store.getters.getSelectedDate)
                    .local()
                    .add(this.numberOfDaysToShow(), "days")) {
            isWithinVisibleSpan = false;
        }
        return isWithinVisibleSpan;
    }
    getDayFromStart(numberOfDays) {
        //returns the date for the day n days ahead of selected date
        const dayNumber = moment(this.$store.getters.getSelectedDate)
            .local()
            .add(numberOfDays, "days")
            .format("DD");
        const month = moment(this.$store.getters.getSelectedDate)
            .local()
            .add(numberOfDays, "days")
            .format("MM");
        const weekday = moment(this.$store.getters.getSelectedDate)
            .local()
            .add(numberOfDays, "days")
            .format("dd");
        const fulldate = moment(this.$store.getters.getSelectedDate)
            .local()
            .add(numberOfDays, "days")
            .format("YYYY-MM-DD");
        return {
            dayNumber,
            month,
            weekday,
            fulldate,
            fromStart: numberOfDays,
        };
    }
    formatTitleDate(date) {
        return window.dateHandler.formatDateNoTime(date);
    }
    getDayOfDate(date) {
        const tempDate = moment(this.$store.getters.getSelectedDate).format("YYYY-MM-" + date);
        return moment(tempDate).format("dd");
    }
    isNextDay(firstDay, secondDay) {
        return (window.dateHandler.formatDateNoTime(secondDay) ===
            window.dateHandler.addDays(firstDay, 1));
    }
    getAbsenceDay(date) {
        return window.dateHandler.getDayOfMonth(date);
    }
    todayAsNumber() {
        return window.dateHandler.getDayOfMonth(new Date());
    }
    onTeamsFilterChange(filter) {
        this.$data.employeeChipFilter = [0];
        if (filter.length == 0) {
            this.$data.teamsChipFilter = [0];
            return;
        }
        if (filter.length > 1 && filter[0] === 0) {
            filter.shift();
            return;
        }
        if (filter.includes(0)) {
            this.$data.teamsChipFilter = [0];
        }
    }
    onEmployeeFilterChange(filter) {
        if (filter.length == 0) {
            this.$data.employeeChipFilter = [0];
            return;
        }
        if (filter.length > 1 && filter[0] === 0) {
            filter.shift();
            return;
        }
        if (filter.includes(0)) {
            this.$data.employeeChipFilter = [0];
        }
    }
    onAbsenceSwitchChanged(showOnlyVacation) {
        if (showOnlyVacation) {
            this.$data.employeeChipFilter = [0];
        }
    }
    selectPreviousWeek() {
        this.$data.loadingVacation = true;
        const newDate = moment(this.$store.getters.getSelectedDate).subtract(1, "week");
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-DD"),
        });
        this.getDateInfo();
        this.initialLoad();
    }
    selectNextWeek() {
        this.$data.loadingVacation = true;
        const newDate = moment(this.$store.getters.getSelectedDate).add(1, "week");
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-DD"),
        });
        this.getDateInfo();
        this.initialLoad();
    }
    selectPreviousMonth() {
        this.$data.loadingVacation = true;
        const newDate = moment(this.$store.getters.getSelectedDate).subtract(1, "month");
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-01"),
        });
        this.getDateInfo();
        this.initialLoad();
    }
    selectNextMonth() {
        this.$data.loadingVacation = true;
        const newDate = moment(this.$store.getters.getSelectedDate).add(1, "month");
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-01"),
        });
        this.getDateInfo();
        this.initialLoad();
    }
    getDateInfo() {
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
};
AbsenceList = __decorate([
    Component({
        data() {
            return {
                teamsChipFilter: [0],
                employeeChipFilter: [0],
                today: moment().format("YYYY-MM-DD"),
                teamCollection: null,
                dateInfo: {
                    year: 0,
                    month: null,
                    week: 0,
                    weekHours: 0,
                    monthHours: 0,
                },
                teamFilters: [],
                monthsToShow: 1,
                users: null,
                absenceReports: [],
                teamMembers: [],
                absenceList: null,
                dayRows: window.dateHandler.getNumberOfDaysInMonth(this.$store.getters.getSelectedDate),
                theme: this.$vuetify.theme.currentTheme,
                selectedDate: this.$store.getters.getSelectedDate,
                showWeeks: false,
                selectedView: 0,
                showLoader: false,
                possibleViews: [
                    { text: "Month", value: 0 },
                    { text: "Week", value: 1 },
                ],
                teams: [],
                filteredUsers: [],
                holidays: null,
                loading: false,
                //new
                userList: [],
                holidayList: null,
                userAbsenceList: null,
                filterView: false,
            };
        },
        created() {
            this.$store.commit("setSelectedDate", {
                date: moment(new Date()).format("YYYY-MM-01"),
            }); //set the first of the month as the date
            this.getDateInfo();
            this.initialLoad();
            //this.loadHolidayData();
            //this.buildUserData();
            //this.getDateInfo();
        },
        components: {
            IconBox,
            IconBoxContent,
            WhiteBox,
        },
        computed: {
            filteredTeams() {
                const teamsFilter = this.$data.teamsChipFilter;
                // if the teamsChipFilter array contains one "All teams", return all teams
                if (teamsFilter.length === 1 && teamsFilter[0] === 0) {
                    return this.$data.teams;
                }
                // return all teams with the array index that is present in the teamsChipFilter array
                return teamsFilter.map((index) => this.$data.teams[index - 1]);
            },
            teamsFilteredEmployees() {
                if (!this.$data.userAbsenceList) {
                    return [];
                }
                //@ts-ignore
                const filteredTeamsIds = this.filteredTeams.map((team) => team.teamId);
                const filteredEmployees = this.$data.userAbsenceList.filter((user) => {
                    return filteredTeamsIds.includes(user.teamId);
                });
                const sortedEmployees = filteredEmployees.toSorted((a, b) => {
                    return `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`);
                });
                // Only show employees with on vacation during period displayed
                if (this.$data.filterView) {
                    return sortedEmployees.filter((user) => {
                        return user.absenceDates.length;
                    });
                }
                return sortedEmployees;
            },
            filteredEmployees() {
                const employeesFilter = this.$data.employeeChipFilter;
                // if the employeeChipFilter array contains one "All employees", return all employees
                if (employeesFilter.length === 1 && employeesFilter[0] === 0) {
                    //@ts-ignore
                    return this.teamsFilteredEmployees;
                }
                // return all employees with the array index that is present in the employeeChipFilter array
                //@ts-ignore
                const filteredEmployees = employeesFilter.map((index) => this.teamsFilteredEmployees[index - 1]);
                if (this.$data.filterView) {
                    if (filteredEmployees.length === 0) {
                        return [];
                    }
                    return filteredEmployees.filter((user) => {
                        return user.absenceDates.length;
                    });
                }
                return filteredEmployees;
            },
            customFilteredUsers() {
                const users = this.$data.filteredUsers.sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`));
                if (this.$data.filterView) {
                    return users.filter((user) => {
                        return user.absenceDates.length;
                    });
                }
                return users;
            },
        },
    })
], AbsenceList);
export default AbsenceList;
